/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openinghoursall2Inputs */

const en_openinghoursall2 = /** @type {(inputs: Openinghoursall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All hours`)
};

const de_openinghoursall2 = /** @type {(inputs: Openinghoursall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Zeiten`)
};

/**
* | output |
* | --- |
* | "All hours" |
*
* @param {Openinghoursall2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const openinghoursall2 = /** @type {((inputs?: Openinghoursall2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openinghoursall2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openinghoursall2(inputs)
	return de_openinghoursall2(inputs)
});
export { openinghoursall2 as "openingHoursAll" }